export default "__VITE_ASSET__Dt3$7nzs__"